import styled from "styled-components";

export const Container = styled.main`
    max-width: 1000px;
    margin: auto;
    margin-top: 50px;
    padding: 0px 50px;
`